import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
// import Autocomplete from '@material-ui/lab/Autocomplete';
import ReactSelectMaterialUi from 'react-select-material-ui';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import Checkbox from '@material-ui/core/Checkbox';
import { ListItem, Select } from '@material-ui/core';
import RequiredButton from '../../components/atoms/RequiredButton';
import AnyButton from '../../components/atoms/AnyButton';
import CancelButton from '../../components/atoms/CancelButton';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import FileUpload from '../../components/molecules/FileUpload';
import GochiMenuEventAddConfirm from './GochiMenuEventAddConfirm';
import { resizeImage, uploadFile, sendLogin } from '../../auth/Auth';
import {
  getGochiMenusEvent,
  addGochiMenuEvent,
  addGochiMenuEventImage
} from '../../actions/GochiMenusEvent';
// import { getShops } from '../../actions/Shop';
import { getOptionGroups } from '../../actions/Options';
import ValidationText from '../../components/atoms/ValidationText';
import { languages, languageType } from '../../constants/Language';

const styles = theme => ({
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      padding: 16
    }
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      marginBottom: 10
    }
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 5px'
    },
    display: 'flex',
    flexDirection: 'column'
  },
  alignEnd: {
    alignSelf: 'end'
  },
  editTable: {
    width: 'auto',
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    },
    '& tr': {
      [theme.breakpoints.down('sm')]: {
        display: 'block'
      }
    }
  },
  tableCellBorderNone: {
    borderBottom: 'none',
    [theme.breakpoints.down('sm')]: {
      borderBottom: 'none',
      display: 'block',
      border: 0
    }
  },
  textField100: {
    padding: '0px 5px 0px 5px',
    width: '100px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  textFieldLong: {
    padding: '0px 5px 0px 5px',
    width: '500px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  button: {
    margin: '5px auto'
  },
  priceCalc: {
    margin: '0px 5px',
    color: '#aaa'
  },
  colLeft: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingBottom: 5
    }
  },
  colRight: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingTop: 0
    }
  },
  hideMobile: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  width100: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      display: 'block',
      padding: 0
    }
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      // account: state.accounts.account,
      name: state.loginInfo.name,
      detail: state.gochiMenus.detail,
      // shops: state.shops.shops,
      // shops: state.options.listShops,
      groups: state.options.listGroups,
      taxTypes: state.gochiMenus.taxTypes,
      reducedTaxMenuPrefix: state.commons.reducedTaxMenuPrefix,
      prefectures: state.commons.prefectures,
      languages
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochiMenusEvent,
          addGochiMenuEvent,
          addGochiMenuEventImage,
          getOptionGroups
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openAddProgress', 'updateOpenAddProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isAddSuccess', 'updateIsAddSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  // withState('shopId', 'setShopId', 0),
  withState('menuChildType', 'setMenuChildType', 1),
  withState('groupId', 'setGroupId', 0),
  withState('groupsError', 'setGroupsError', ''),
  withState('groups', 'setGroups', []),
  withState('shops', 'setShops', []),
  withState('shopName', 'setShopName', ''),
  withState('shopNameError', 'setShopNameError', ''),
  withState('menuEventName', 'setMenuEventName', ''),
  withState('menuEventNameError', 'setMenuEventNameError', ''),
  withState('menuName', 'setMenuName', ''),
  withState('menuNameError', 'setMenuNameError', ''),
  withState('price', 'setPrice', ''),
  withState('priceError', 'setPriceError', ''),
  withState('priceCalc', 'setPriceCalc', '0 (税抜 0)'),
  withState('displayAmount', 'setDisplayAmount', 0),
  withState('displayAmountError', 'setDisplayAmountError', ''),
  withState('description', 'setDescription', ''),
  withState('taxType', 'setTaxType', 'EXTERNAL'),
  withState('reducedTaxCheck', 'setReducedTaxCheck', false),
  withState('reducedTaxType', 'setReducedTaxType', 'UNREDUCED'),
  withState('prefectureCode', 'setPrefectureCode', 0),
  withState('prefecturesError', 'setPrefecturesError', ''),
  withState('tagStr', 'setTagStr', ''),
  withState('tags', 'setTags', null),
  withState('image', 'setImage', null),
  withState('previewImage', 'setPreviewImage', null),
  withState('showHide', 'setShowHide', 1),
  withState('menuType', 'setMenuType', 'EVENT'),
  withState('manual', 'setManual', 0),
  withState('menuCombo', 'setMenuCombo', 0),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  withState('translateType', 'setTranslateType', 0),
  withState('multiLangData', 'setMultiLangData', {}),
  withState('gochimeshiFlag', 'setGochimeshiFlag', 1),
  withState('menuLimitTotal', 'setMenuLimitTotal', 0),
  withState('isETicket', 'setIsETicket', 1),
  withState('premiumPercent', 'setPremiumPercent', 0),
  withState('premiumPercentError', 'setPremiumPercentError', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.actions.getOptionGroups().then(data => {
        this.props.checkSession(data);
        this.props.setGroups(data.payload.list);
      });
      let dataFirst = {};
      const origilData = {
        menuChildType: null,
        groupId: null,
        menuEventName: null,
        menuName: null,
        price: null,
        description: null,
        taxType: null,
        reducedTaxType: null,
        // displayAmount: null,
        premiumPercent: null,
        menuLimitTotal: null,
        prefectureCode: null,
        tagStr: null,
        manual: null,
        menuCombo: null,
        showHide: null,
        menuType: null,
        gochimeshiFlag: null
      };
      const arr = [];
      languages.forEach(item => {
        if (item.value === languageType.ORIGIN) {
          dataFirst = origilData;
        } else {
          const other = {
            translateType: 0,
            language: item.value
          };
          arr.push(other);
        }
      });
      dataFirst.otherLanguages = arr;
      this.props.setMultiLangData(dataFirst);
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    searchKey, // roles,
    openAddConfirm,
    updateOpenAdd,
    updateOpenAddConfirm,
    openAddProgress,
    updateOpenAddProgress,
    loading,
    updateLoading,
    isAddSuccess,
    updateIsAddSuccess,
    resultMessage,
    setResultMessage,
    groupsError,
    setGroupsError,
    menuChildType,
    groupId,
    setGroupId,
    groups,
    shopId, // setShopId,
    // shopName,
    setShopName,
    shops,
    menuEventName,
    setMenuEventName,
    menuName,
    setMenuName,
    price,
    setPrice,
    priceCalc,
    setPriceCalc,
    // displayAmount,
    // setDisplayAmount,
    description,
    setDescription,
    taxType,
    setTaxType,
    taxTypes,
    reducedTaxCheck,
    setReducedTaxCheck,
    reducedTaxType,
    setReducedTaxType,
    prefectures,
    prefectureCode,
    setPrefectureCode,
    prefecturesError,
    setPrefecturesError,
    tagStr,
    setTagStr,
    // tags,
    // setTags,
    image,
    setImage,
    previewImage,
    setPreviewImage,
    reducedTaxMenuPrefix, // shopNameError,
    // setShopNameError,
    menuEventNameError,
    // setMenuEventNameError,
    menuNameError,
    setMenuNameError,
    priceError,
    setPriceError,
    // displayAmountError,
    // setDisplayAmountError,
    showHide,
    menuType,
    manual,
    setManual,
    menuCombo,
    setMenuCombo,
    isLanguage,
    setIsLanguage,
    multiLangData,
    setMultiLangData,
    translateType,
    setTranslateType,
    gochimeshiFlag,
    setGochimeshiFlag,
    menuLimitTotal,
    setMenuLimitTotal,
    premiumPercent,
    setPremiumPercent,
    premiumPercentError,
    setPremiumPercentError,
    isETicket,
    setIsETicket
  }) => {
    const errors = {
      groupsError,
      // shopNameError,
      menuEventNameError,
      menuNameError,
      priceError,
      // displayAmountError,
      premiumPercentError,
      prefecturesError
    };
    const validMenuName = () => {
      if (isLanguage !== languageType.ORIGIN && translateType === 0) {
        return 0;
      }
      const value = menuName;
      if (value.trim() === '') {
        setMenuNameError('必須項目です。');
        return 1;
      }
      setMenuNameError('');
      setMenuName(value);
      return 0;
    };
    const validPrice = () => {
      const value = price;
      if (manual === 0) {
        if (value === '') {
          setPriceError('必須項目です。');
          return 1;
        }
        if (!/^\d+$/.test(value)) {
          setPriceError('半角数字のみ入力してください。');
          return 1;
        }
      }
      setPriceError('');
      setPrice(value);
      return 0;
    };
    // const validDisplayAmount = () => {
    //   const value = displayAmount;
    //   if (value === 0) {
    //     setDisplayAmountError('必須項目です。');
    //     return 1;
    //   }
    //   if (!/^\d+$/.test(value)) {
    //     setDisplayAmountError('半角数字のみ入力してください。');
    //     return 1;
    //   }
    //   setDisplayAmountError('');
    //   setDisplayAmount(value);
    //   return 0;
    // };
    const validPremiumPercent = () => {
      const value = premiumPercent;
      if (value === '') {
        setPremiumPercentError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setPremiumPercentError('プレミアム率を正しくご入力ください。');
        return 1;
      }
      setPremiumPercentError('');
      setPremiumPercent(value);
      return 0;
    };
    const validGroups = () => {
      const value = groupId;
      if (value === 0) {
        setGroupsError('必須項目です。');
        return 1;
      }
      setGroupsError('');
      setGroupId(value);
      return 0;
    };
    const validPrefectures = () => {
      const value = prefectureCode;
      if (value === 0) {
        setPrefecturesError('必須項目です。');
        return 1;
      }
      setPrefecturesError('');
      setPrefectureCode(value);
      return 0;
    };
    const valid = () => {
      let errorCount = 0;
      if (validPrefectures() === 0) {
        errorCount =
          // validMenuEventName() +
          validMenuName() +
          validPrice() +
          validPremiumPercent() +
          validPrefectures();
      } else if (validGroups() === 0) {
        errorCount =
          // validMenuEventName() +
          validMenuName() +
          validPrice() +
          validPremiumPercent() +
          validGroups();
      } else {
        errorCount =
          // validMenuEventName() +
          validMenuName() +
          validPrice() +
          validPremiumPercent() +
          validGroups() +
          validPrefectures();
      }
      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const calcPrice = e => {
      let includedTaxPrice = 0;
      let excludedTaxPrice = 0;

      let latestPrice = price;
      if (e.target.id === 'price') {
        latestPrice = e.target.value;
      }

      let latestTaxType = taxType;
      if (e.target.name === 'taxType') {
        latestTaxType = e.target.value;
      }

      // TODO DBから取得
      let tax = 0.1;
      if (
        (e.target.id !== 'reducedTax' && reducedTaxCheck) ||
        (e.target.id === 'reducedTax' && e.target.checked)
      ) {
        // TODO DBから取得
        tax = 0.08;
      }

      if (latestPrice !== '') {
        if (latestTaxType === 'INTERNAL') {
          const amountTemp = parseFloat((latestPrice / (1 + tax)).toFixed(9));
          const taxAmount = Math.round(amountTemp * tax);
          includedTaxPrice = latestPrice;
          excludedTaxPrice = latestPrice - taxAmount;
        } else if (latestTaxType === 'DONATION') {
          includedTaxPrice = latestPrice;
          excludedTaxPrice = latestPrice;
        } else {
          const taxAmount = Math.round(latestPrice * tax);
          includedTaxPrice = latestPrice * 1 + taxAmount;
          excludedTaxPrice = latestPrice;
        }
      }

      setPriceCalc(`${includedTaxPrice} (税抜 ${excludedTaxPrice})`);
    };
    // const splitTagStr = str => {
    //   if (str === '') {
    //     setTags(null);
    //   } else {
    //     setTags(
    //       str.split(/\s+/).map(t => {
    //         return { tagName: t };
    //       })
    //     );
    //   }
    // };
    const convertReducedTax = checked => {
      if (checked) {
        setReducedTaxType('REDUCED');
      } else {
        setReducedTaxType('UNREDUCED');
      }
    };
    const setShopNameData = id => {
      shops.forEach(item => {
        if (id === item.shopId) {
          setShopName(item.shopName);
        }
      });
    };

    const getCurrentData = () => {
      const lang = isLanguage;
      let data = multiLangData;
      const origilParam = {
        menuChildType,
        groupId,
        menuEventName,
        menuName,
        price,
        description,
        taxType,
        reducedTaxType,
        // displayAmount,
        premiumPercent,
        menuLimitTotal: manual === 1 ? undefined : menuLimitTotal,
        prefectureCode,
        tagStr,
        manual,
        menuCombo,
        showHide,
        menuType,
        gochimeshiFlag,
        isETicket
      };
      const otherParam = {
        translateType,
        language: lang,
        params: {
          menuEventName,
          menuName,
          description
        }
      };
      // origin
      if (lang === languageType.ORIGIN) {
        data = { ...data, ...origilParam };
      } else {
        // other languages
        for (let index = 0; index < data.otherLanguages.length; index += 1) {
          if (data.otherLanguages[index].language === lang) {
            data.otherLanguages[index] = otherParam;
          }
        }
      }
      const str = JSON.stringify(data);
      return JSON.parse(str);
    };

    const cancelAction = () => updateOpenAdd(false);
    const confirmAction = () => {
      if (!valid()) {
        alert('登録情報を正しく入力してください。');
      } else {
        setShopNameData(shopId);
        setMultiLangData(getCurrentData());
        updateOpenAddConfirm(true);
      }
    };
    const backAction = () => updateOpenAddConfirm(false);
    const registerAction = async () => {
      const param = {
        ...multiLangData,
        otherLanguages:
          multiLangData.manual === 0 ? multiLangData.otherLanguages : []
      };
      updateLoading(true);
      updateOpenAddProgress(true);
      const addedMenu = await actions
        .addGochiMenuEvent(param)
        .then(data => checkSession(data));
      if (image !== null) {
        let imageData = image;
        if (imageData.size > Number(process.env.REACT_APP_RESIZE_BORDER)) {
          const { resizeImageFile } = await resizeImage(imageData);
          imageData = resizeImageFile;
        }
        const imagePath = await uploadFile(
          'menu_event',
          addedMenu.payload.menuEventId,
          imageData,
          'public'
        );
        actions
          .addGochiMenuEventImage(addedMenu.payload.menuEventId, {
            image: imagePath
          })
          .then(data => checkSession(data));
      }
      if (addedMenu.type === 'ADD_GOCHI_MENU_EVENT_SUCCESS') {
        updateIsAddSuccess(true);
        actions.getGochiMenusEvent(searchKey).then(data => checkSession(data));
        setResultMessage('登録が完了しました。');
        updateLoading(false);
      } else {
        updateIsAddSuccess(false);
        setResultMessage('登録に失敗しました。');
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isAddSuccess) {
        updateOpenAdd(false);
        updateOpenAddConfirm(false);
        updateOpenAddProgress(false);
      } else {
        updateOpenAddProgress(false);
      }
    };

    const getGroupOptions = () => {
      const groupOptions = [];
      groups.forEach(group => {
        groupOptions.push({
          label: group.groupName,
          value: String(group.groupId)
        });
      });
      return groupOptions;
    };

    const getPrefectureOptions = () => {
      const prefectureOptions = [];
      prefectures.forEach(prefecture => {
        prefectureOptions.push({
          label: prefecture.name,
          value: prefecture.id
        });
      });
      return prefectureOptions;
    };

    const setLanguage = v => {
      const lang = isLanguage;
      const data = getCurrentData();
      if (
        (v !== languageType.ORIGIN && lang === languageType.ORIGIN) ||
        (v !== languageType.ORIGIN && lang !== languageType.ORIGIN)
      ) {
        // origin to other or other to other lang
        for (let k = 0; k < multiLangData.otherLanguages.length; k += 1) {
          if (multiLangData.otherLanguages[k].language === v) {
            setMenuName(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.menuName
                ? multiLangData.otherLanguages[k].params.menuName
                : ''
            );
            setDescription(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.description
                ? multiLangData.otherLanguages[k].params.description
                : ''
            );
            setTranslateType(
              multiLangData.otherLanguages[k].translateType
                ? multiLangData.otherLanguages[k].translateType
                : 0
            );
            setMenuEventName(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.menuEventName
                ? multiLangData.otherLanguages[k].params.menuEventName
                : ''
            );
          }
        }
      } else if (v === languageType.ORIGIN) {
        // other to origin
        setMenuName(multiLangData.menuName);
        setDescription(multiLangData.description);
        setMenuEventName(multiLangData.menuEventName);
      }
      setIsLanguage(v);
      setMultiLangData(data);
    };

    const handleChangeManual = value => {
      setManual(value);
      setMenuLimitTotal(0);
      setPrice('');
      setPriceCalc('0 (税抜 0)');
      setTaxType('EXTERNAL');
      setReducedTaxCheck(false);
      setReducedTaxType('UNREDUCED');
    };

    return (
      <div className={classes.root}>
        <div className={classes.pageTitle}>
          <Typography variant="h6">メニュー登録</Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <Select
            className={`${classes.textField} ${classes.alignEnd}`}
            value={isLanguage}
            disabled={manual === 1}
            onChange={e => {
              if (isLanguage === e.target.value) {
                return;
              }
              if (
                valid() ||
                (isLanguage !== languageType.ORIGIN && translateType === 0)
              ) {
                setLanguage(e.target.value);
              } else {
                alert('登録情報を正しく入力してください。');
              }
            }}
          >
            {languages.map(lang => (
              <MenuItem key={lang.value} value={lang.value}>
                {lang.label}
              </MenuItem>
            ))}
          </Select>
          {isLanguage !== languageType.ORIGIN && (
            <ListItem className={classes.itemForm}>
              <Typography component="div" className={classes.formInput}>
                <RadioGroup
                  value={translateType}
                  onChange={e => {
                    setTranslateType(parseInt(e.target.value, 10));
                  }}
                >
                  <FormControlLabel
                    value={0}
                    control={<Radio color="primary" />}
                    label="GG翻訳を選択"
                  />
                  <FormControlLabel
                    value={1}
                    control={<Radio color="primary" />}
                    label="自分で文章入力"
                  />
                </RadioGroup>
              </Typography>
            </ListItem>
          )}
          <Table className={classes.editTable}>
            <TableBody>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <AnyButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    label="イベント名"
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setMenuEventName(e.target.value);
                    }}
                    value={menuEventName}
                    inputProps={{
                      maxLength: isLanguage === languageType.ORIGIN ? 250 : 1000
                    }}
                    disabled={
                      isLanguage !== languageType.ORIGIN && translateType === 0
                    }
                    // onBlur={validMenuEventName}
                  />
                  {/* <ValidationText message={errors.menuEventNameError} /> */}
                </TableCell>
                <TableCell className={classes.width100} />
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <Typography className={classes.description}>
                    チケット発行種別
                  </Typography>
                  <RadioGroup
                    row
                    value={isETicket}
                    onChange={e => {
                      setIsETicket(parseInt(e.target.value, 10));
                    }}
                  >
                    <FormControlLabel
                      value={1}
                      control={<Radio color="primary" />}
                      label="電子"
                    />
                    <FormControlLabel
                      value={0}
                      control={<Radio color="primary" />}
                      label="紙印刷"
                    />
                  </RadioGroup>
                </TableCell>
                <TableCell className={classes.width100} />
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    required
                    label="メニュー名"
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setMenuName(e.target.value);
                    }}
                    onBlur={validMenuName}
                    value={menuName}
                    inputProps={{
                      maxLength: isLanguage === languageType.ORIGIN ? 250 : 1000
                    }}
                    disabled={
                      isLanguage !== languageType.ORIGIN && translateType === 0
                    }
                  />
                  {(isLanguage === languageType.ORIGIN ||
                    translateType === 1) && (
                    <ValidationText message={errors.menuNameError} />
                  )}
                </TableCell>
                <TableCell className={classes.width100} />
              </TableRow>
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.colLeft}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    <RadioGroup
                      row
                      value={manual}
                      onChange={e => {
                        handleChangeManual(parseInt(e.target.value, 10));
                      }}
                    >
                      <FormControlLabel
                        value={0}
                        control={<Radio color="primary" />}
                        label="イベントメニューの自動挿入"
                      />
                      <FormControlLabel
                        value={1}
                        control={<Radio color="primary" />}
                        label="イベントメニューのマニュアルで挿入"
                      />
                    </RadioGroup>
                  </TableCell>
                  <TableCell className={classes.width100} />
                </TableRow>
              )}
              {manual === 0 && isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.colLeft}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    <Typography className={classes.description}>
                      利用方法
                    </Typography>
                    <RadioGroup
                      row
                      value={menuLimitTotal}
                      onChange={e => {
                        setMenuLimitTotal(parseInt(e.target.value, 10));
                      }}
                    >
                      <FormControlLabel
                        value={0}
                        control={<Radio color="primary" />}
                        label="一枚単位利用"
                      />
                      <FormControlLabel
                        value={1}
                        control={<Radio color="primary" />}
                        label="一円単位利用"
                      />
                    </RadioGroup>
                  </TableCell>
                  <TableCell className={classes.width100} />
                </TableRow>
              )}
              {manual === 0 && isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.colLeft}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    <TextField
                      id="price"
                      required
                      label="価格"
                      className={classes.textField}
                      margin="normal"
                      onChange={e => {
                        setPrice(e.target.value);
                        calcPrice(e);
                      }}
                      onBlur={validPrice}
                      value={price}
                    />
                    <ValidationText message={errors.priceError} />
                    <div className={classes.priceCalc}>{priceCalc}</div>
                  </TableCell>
                  <TableCell className={classes.width100} />
                </TableRow>
              )}
              {/* {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.colLeft}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    <TextField
                      required
                      label="表示金額"
                      className={classes.textField}
                      margin="normal"
                      onChange={e => {
                        setDisplayAmount(e.target.value);
                      }}
                      onBlur={validDisplayAmount}
                      value={displayAmount}
                    />
                    <ValidationText message={errors.displayAmountError} />
                  </TableCell>
                  <TableCell className={classes.width100} />
                </TableRow>
              )} */}
              {manual === 0 && isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.colLeft}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    <div>
                      <TextField
                        id="taxType"
                        name="taxType"
                        select
                        label="税区分・寄付"
                        className={classes.textField}
                        margin="normal"
                        value={taxType}
                        onChange={e => {
                          setTaxType(e.target.value);
                          calcPrice(e);
                        }}
                        InputLabelProps={{
                          shrink: true
                        }}
                      >
                        {taxTypes.map(group => {
                          return (
                            <MenuItem key={group.id} value={group.id}>
                              {group.name}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </div>
                    <FormControlLabel
                      control={<Checkbox id="reducedTax" color="primary" />}
                      label="軽減税率対象"
                      checked={reducedTaxCheck}
                      onChange={e => {
                        setReducedTaxCheck(e.target.checked);
                        convertReducedTax(e.target.checked);
                        calcPrice(e);
                      }}
                    />
                  </TableCell>
                  <TableCell className={classes.width100} />
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.colLeft}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    <TextField
                      required
                      label="プレミアム率"
                      className={classes.textField}
                      margin="normal"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">%</InputAdornment>
                        )
                      }}
                      onChange={e => {
                        setPremiumPercent(e.target.value);
                      }}
                      onBlur={validPremiumPercent}
                      value={premiumPercent}
                    />
                    <ValidationText message={errors.premiumPercentError} />
                  </TableCell>
                  <TableCell className={classes.width100} />
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.tableCellBorderNone}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone}>
                    <ReactSelectMaterialUi
                      required
                      label="都道府県"
                      className={classes.textField}
                      defaultValue={String(prefectureCode)}
                      options={getPrefectureOptions()}
                      margin="normal"
                      onChange={e => {
                        setPrefectureCode(e);
                      }}
                      SelectProps={{
                        isClearable: true,
                        msgNoOptionsMatchFilter:
                          '名前が部分一致する都道府県がありません'
                      }}
                      onBlur={validPrefectures}
                    />
                    <ValidationText message={errors.prefecturesError} />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone} />
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.tableCellBorderNone} />
                  <TableCell className={classes.tableCellBorderNone}>
                    <ReactSelectMaterialUi
                      required
                      label="グループ"
                      className={classes.textField}
                      defaultValue={String(groupId)}
                      // value={String(groupId)}
                      options={getGroupOptions()}
                      margin="normal"
                      onChange={v => {
                        setGroupId(Number(v));
                      }}
                      SelectProps={{
                        isClearable: true,
                        msgNoOptionsMatchFilter:
                          '名前が部分一致するグループがありません'
                      }}
                      onBlur={validGroups}
                    />
                    <ValidationText message={errors.groupsError} />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone} />
                </TableRow>
              )}
              <TableRow>
                <TableCell className={classes.width100} />
                <TableCell className={classes.width100} />
                <TableCell className={classes.width100} />
              </TableRow>
              {manual === 1 && isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.colLeft}>
                    <AnyButton />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    <RadioGroup
                      row
                      value={menuCombo}
                      onChange={e => {
                        setMenuCombo(parseInt(e.target.value, 10));
                      }}
                    >
                      <FormControlLabel
                        value={0}
                        control={<Radio color="primary" />}
                        label="回数券ではないチケット"
                      />
                      <FormControlLabel
                        value={1}
                        control={<Radio color="primary" />}
                        label="回数券チケット"
                      />
                    </RadioGroup>
                  </TableCell>
                  <TableCell className={classes.width100} />
                </TableRow>
              )}
              {manual === 0 && isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.colLeft}>
                    <AnyButton />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    <Typography className={classes.description}>
                      適用対象
                    </Typography>
                    <RadioGroup
                      row
                      value={gochimeshiFlag}
                      onChange={e => {
                        setGochimeshiFlag(parseInt(e.target.value, 10));
                      }}
                    >
                      <FormControlLabel
                        value={1}
                        control={<Radio color="primary" />}
                        label="全ごちめしシステム"
                      />
                      <FormControlLabel
                        value={0}
                        control={<Radio color="primary" />}
                        label="本イベントだけ"
                      />
                    </RadioGroup>
                  </TableCell>
                  <TableCell className={classes.width100} />
                </TableRow>
              )}
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <AnyButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    label="説明"
                    multiline
                    rows="4"
                    className={classes.textFieldLong}
                    margin="normal"
                    onChange={e => {
                      setDescription(e.target.value);
                    }}
                    value={description}
                    inputProps={{
                      maxLength:
                        isLanguage === languageType.ORIGIN ? 1000 : 2500
                    }}
                    disabled={
                      isLanguage !== languageType.ORIGIN && translateType === 0
                    }
                  />
                </TableCell>
                <TableCell className={classes.width100} />
              </TableRow>
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.colLeft}>
                    <AnyButton />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    <TextField
                      label="タグ"
                      className={classes.textFieldLong}
                      margin="normal"
                      onChange={e => {
                        setTagStr(e.target.value);
                        // splitTagStr(e.target.value);
                      }}
                      value={tagStr}
                    />
                  </TableCell>
                  <TableCell>
                    #おすすめ #おふくろの味 #学生に ＃ガッツリ
                    などメニューの特徴を表すタグを記載できます。
                  </TableCell>
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colLeft]}
                  >
                    <AnyButton />
                  </TableCell>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colRight]}
                  >
                    <FileUpload
                      label="image"
                      setFile={setImage}
                      previewImage={previewImage}
                      setPreviewImage={setPreviewImage}
                    />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Paper>
        <div>
          <CancelButton onClickAction={cancelAction} color="primary" />
          <ConfirmButton onClickAction={confirmAction} />
        </div>
        <Modal open={openAddConfirm}>
          <GochiMenuEventAddConfirm
            backAction={backAction}
            registerAction={registerAction}
            addConfirm={multiLangData}
            reducedTaxMenuPrefix={reducedTaxMenuPrefix}
            openAddProgress={openAddProgress}
            progressOkAction={progressOkAction}
            loading={loading}
            resultMessage={resultMessage}
            previewImage={previewImage}
            currentLanguage={isLanguage}
            reducedTaxCheck={reducedTaxCheck}
            groups={groups}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
